import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Button, Heading, Text, Alert, Stack } from '@/components/lib'
import useStore from '../../store'
import api from '../../api'
import utils from '../../utils/utils'

import EntryContainer from '../includes/EntryContainer'
import Login from './Login'
import useTitle from '../../hooks/useTitle'

export default function JoinTeam () {
  const { user } = useStore()
  const navigate = useNavigate()
  const [invitation, setInvitation] = useState(null)
  const [loading, setLoading] = useState(true)
  const [accepting, setAccepting] = useState(false)
  const [declining, setDeclining] = useState(false)
  const [error, setError] = useState(null)
  useTitle('Join Team')

  const params = new URLSearchParams(window.location.search)
  const token = params.get('token')

  useEffect(() => {
    if (!token) {
      setError('No invitation token found.')
      setLoading(false)
      return
    }
    api.invitations.get(token, (data) => {
      setInvitation(data)
      setLoading(false)
    }, (err) => {
      setError(err.message || 'This invitation is invalid or has expired.')
      setLoading(false)
    })
  }, [token])

  function accept () {
    setAccepting(true)
    setError(null)
    api.invitations.accept(token, () => {
      utils.toast('success', 'Invitation accepted.')
      window.location.href = '/trials'
    }, (err) => {
      setAccepting(false)
      setError(err.message || 'There was a problem accepting the invitation.')
    })
  }

  if (loading) {
    return <EntryContainer asLoader />
  }

  if (error && !invitation) {
    return (
      <EntryContainer>
        <Stack spacing={4}>
          <Heading size='lg'>Invalid invitation</Heading>
          <Alert status='error' withIcon title='There was a problem'>
            <Text>{error}</Text>
          </Alert>
        </Stack>
      </EntryContainer>
    )
  }

  if (!user) {
    return <Login invitationBanner={`You've been invited to join ${invitation?.team?.name} on Trialflare. Please log in to accept the invitation.`} />
  }

  return (
    <EntryContainer>
      <Stack spacing={5}>
        <Heading size='lg'>Team invitation</Heading>

        <Alert status='info' variant='left-accent' rounded='md' shadow='md'>
          <Text>
            {invitation?.invitedBy
              ? <><strong>{invitation.invitedBy.firstName} {invitation.invitedBy.lastName}</strong> has invited you</>
              : 'You have been invited'} to join <strong>{invitation?.team?.name}</strong> on Trialflare.
          </Text>
        </Alert>

        <Text>
          Accepting this invitation will switch your active team to <strong>{invitation?.team?.name}</strong>.
          You can switch between your teams at any time from the navigation bar.
        </Text>

        {error &&
          <Alert status='error' withIcon title='There was a problem'>
            <Text>{error}</Text>
          </Alert>}

        <Stack direction='row'>
          <Button colorPalette='primary' onClick={accept} isLoading={accepting}>
            Accept invitation
          </Button>
          <Button
            variant='ghost' isLoading={declining} onClick={() => {
              setDeclining(true)
              api.invitations.decline(token, () => navigate('/trials'), () => navigate('/trials'))
            }}
          >
            Decline
          </Button>
        </Stack>
      </Stack>
    </EntryContainer>
  )
}
